import React, { useState } from 'react';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import { apiUrl, businessName } from '../../utils/consts';
import { formatMoney } from '../../utils/formatMoney';
import { uploadImage } from '../../utils/files';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import './styles/descuentoNomina.scss';

const select = state => {
  return {
    user: state.auth.user,
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedDescuentoNomina(props) {

  const [validated, setValidated] = useState(false);
  const [creating, setCreating] = useState(false);
  const [transactionStatus, setTransactionStatus] = useState();
  const [name, setName] = useState('');
  const [document, setDocument] = useState('');
  const [signFile, setSignFile] = useState();

  const createPayment = async () => {

    const {
      token,
      userId,
      amount,
      paymentType,
      benefitCategory,
      products,
      deliveryInfo,
      benefitApplicationId,
      requestedBenefitId
    } = props;

    const imgUrl = await uploadImage(signFile[0]);
    const body = {
      userId,
      token,
      businessName,
      amount,
      products,
      paymentMethod: 'DESCUENTO_NOMINA',
      paymentType,
      benefitCategory,
      startDate: new Date(),
      endDate: new Date(),
      userName: name,
      userDocument: document,
      userSign: imgUrl,
      benefitApplicationId,
      requestedBenefitId
    };

    if (products && products.length > 0 && deliveryInfo) {
      body.deliveryInfo =
        deliveryInfo.street + " " +
        (deliveryInfo.extra ? deliveryInfo.extra : '') + " " +
        (deliveryInfo.area ? deliveryInfo.area : '') + ", " +
        deliveryInfo.city + ", " +
        deliveryInfo.state + ", " +
        deliveryInfo.country + ", " +
        deliveryInfo.phone;
    }

    const paymentResponse = await fetch(`${apiUrl}/payments/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });

    const paymentData = await paymentResponse.json();

    return paymentData.success;
  };

  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);
    const form = event.currentTarget;

    if (!signFile || !signFile[0]) return alert('Debes subir una firma.');

    if (form.checkValidity()) {
      setCreating(true);

      const success = await createPayment();

      setTransactionStatus(success ? 'SUCCESS' : 'ERROR');
    }
  };

  const handleFileChange = event => {
    if (event.target.files[0]) setSignFile(event.target.files);
    else setSignFile(undefined);
  }

  const finishTransaction = () => {
    props.history.push('/');
    if (props.onFinishTransaction) props.onFinishTransaction();
  };

  if (transactionStatus) {
    return (
      <div className="descuento-nomina-component">
        <h3 className="transaction-message transaction-status-message">
          {
            transactionStatus === 'SUCCESS' ?
            <>
              Gracias por usar nibi.<br />
              En los siguientes días nos comunicaremos contigo a través de tu correo electrónico para informarte el resultado de este pago.
              <Button
                className="app-button"
                style={{ width: 'fit-content', marginTop: '15px' }}
                onClick={finishTransaction}
              >
                Volver a la página principal
              </Button>
            </> :
            'Error al procesar la transacción. Inténtalo nuevamente o comunícate con nosotros.'
          }
        </h3>
      </div>
    );
  }

  return (
    <div className="descuento-nomina-component">
      <Form noValidate validated={validated} onSubmit={handleSubmit} inline>
        <Col xs={12}>
          <p className="form-content">
            Bogotá D.C., {moment(new Date()).format('YYYY-MM-DD')}<br />
            <strong>Señor pagador </strong><br />

            Autorizo irrevocablemente al Fondo de Empleados de Cemex Colombia -FECEM para descontar la suma de
            <Form.Control
              style={{ margin: '0 5px' }}
              value={`$${formatMoney(props.amount)}`}
              disabled={true}
              size="sm"
            />
            de manera
            <span style={{ display: 'inline-block', margin: '0 5px' }}>
              <div style={{ display: 'flex', width: 'fit-content' }}>
                <Form.Check
                  id={`custom-inline-radio-1`}
                  type="radio"
                  label="Ocasional"
                  disabled={true}
                  checked={true}
                  inline
                />
                <Form.Check
                  id={`custom-inline-radio-2`}
                  type="radio"
                  label="Mensual"
                  disabled={true}
                  checked={false}
                  inline
                />
              </div>
            </span><br />
            desde el mes de
            <Form.Control
              value={moment(new Date()).format('YYYY-MM')}
              disabled={true}
              style={{ margin: '0 5px' }}
              inline
              size="sm"
            />
            hasta el mes de
            <Form.Control
              value={moment(new Date()).format('YYYY-MM')}
              disabled={true}
              style={{ margin: '0 5px' }}
              size="sm"
              inline
            />
            con destino al fondo de donaciones.<br /><br />

            <strong>Cordialmente,</strong><br />

            <Form.Row>
              <Col xs={4}><strong>Nombre</strong></Col>
              <Col xs={8}>
                <Form.Control
                  type="text"
                  style={{ width: '100%' }}
                  onChange={event => setName(event.target.value)}
                  value={name}
                  size="sm"
                  required
                />
              </Col>

              <Col xs={4}><strong>Cédula</strong></Col>
              <Col xs={8}>
                <Form.Control
                  type="text"
                  style={{ width: '100%' }}
                  onChange={event => setDocument(event.target.value)}
                  value={document}
                  size="sm"
                  required
                />
              </Col>

              <Col xs={4}><strong>Firma</strong></Col>
              <Col xs={8}>
                <div style={{ lineHeight: '30px', marginTop: '10px' }}>
                  <Form.Control
                    type="file"
                    style={{ display: 'inline-block', width: '100%' }}
                    size="sm"
                    files={signFile}
                    onChange={handleFileChange}
                    accept="image/*"
                    required
                  />
                </div>
              </Col>
            </Form.Row>
          </p>

          <Button className="app-button" type="submit" disabled={creating}>
            {
              creating ? <Spinner animation="border" size="sm" variant="warning" /> : 'Confirmar'
            }
          </Button>

        </Col>
      </Form>
    </div>
  );
}

const DescuentoNomina = connect(select)(ConnectedDescuentoNomina);

export default withRouter(DescuentoNomina);
